// Actions
import LoadingAction from "@common/redux/actions/LoadingAction";
import AgeVerificationAction from "@common/redux/actions/AgeVerificationAction";

// Helpers
import { handleError } from "@common/components/helpers/error";

// Client
import AgeVerificationClient from "@common/api/AgeVerificationClient";
import AgeVerificationConfigClient from "@common/api/AgeVerificationConfigClient";

import { formatForSelect } from "./formOptions";

const fetchAgeVerificationData = () => {
  LoadingAction.set(true).then(() => {
    AgeVerificationClient.MetaData()
      .then(
        (response) => {
          AgeVerificationConfigClient.Read().then((config) => {
            AgeVerificationAction.dispatch({
              idTypes: formatForSelect(response.idTypes),
              genders: formatForSelect(response.genders),
              record: response.record,
              config: config.record,
            });
          });
        },
        (error) => handleError(error),
      )
      .finally(() => LoadingAction.set(false));
  });
};

export default fetchAgeVerificationData;
